import { z } from "zod";

export const stepSchema = z.object({
	name: z.string(),
	configuration: z.record(z.string(), z.union([z.boolean(), z.string()])).nullable(),
});

export const dataPipelineSchema = z.object({
	name: z.string(),
	filterSteps: z.array(stepSchema),
	sortSteps: z.array(stepSchema),
	rulesSteps: z.array(stepSchema),
});

export const selectionPipelineSchema = z.object({
	tenantId: z.string(),
	id: z.string(),
	dataPipeline: dataPipelineSchema,
});

export type SelectionPipelineConfiguration = z.infer<typeof selectionPipelineSchema>;
export type SelectionDataPipeline = z.infer<typeof dataPipelineSchema>;
export type SelectionStep = z.infer<typeof stepSchema>;
